@if (loadingState() === 'loading') {
  <p class="text-sm text-secondary m-0 p-4">Loading creator…</p>
} @else if (loadingState() === 'error') {
  <p class="text-sm text-red-600 m-0 p-4" role="alert">Failed to load creator.</p>
} @else if (creator(); as c) {
  <div
    class="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden rounded-xl border border-zinc-200 shadow-sm dark:border-zinc-800 h-full">
    <div class="shrink-0 px-2 py-2 flex flex-row items-center justify-between drawer-header-primary">
      <div class="flex items-center gap-x-4 min-w-0">
        <div class="shrink-0 size-10 overflow-hidden rounded-full">
          @if (c.photoURL) {
            <img [src]="imageService.getImageSource(c.photoURL, 'gallery')" alt="" class="size-full object-cover" />
          } @else {
            <img
              src="https://ionicframework.com/docs/img/demos/avatar.svg"
              alt=""
              class="size-full object-cover opacity-80" />
          }
        </div>
        <div class="min-w-0">
          <h3 class="text-base font-semibold text-gray-900 dark:text-white m-0 truncate">
            {{ c.firstName }} {{ c.lastName }}
          </h3>
          <p class="text-sm text-gray-500 dark:text-gray-400 m-0 truncate">{{ c.blazeFirebaseUid }}</p>
        </div>
      </div>

      <nav aria-label="Creator insight sections" class="flex flex-row justify-end gap-x-2 shrink-0 overflow-x-auto">
        @for (item of navItems(); track item.section) {
          <button
            type="button"
            class="inline-flex items-center border-b-2 px-2 py-2 text-sm font-medium whitespace-nowrap cursor-pointer bg-transparent"
            [class]="getNavClass(item)"
            (click)="goToSection(item)">
            {{ item.label }}
          </button>
        }
      </nav>
    </div>

    <div class="creator-insights-outlet-host p-2 scrollbar-transparent">
      <router-outlet />
    </div>
  </div>
}
